<template>
  <section class="section hub-job" >
		<div class="container mx-auto flex flex-wrap items-center">

      <div class="section-title__wrapper px-4">
        <h3 class="section-title">{{ computedPayload['section-title'] }}</h3>
      </div>
      <div class="section-btn__wrapper px-4">
        <a class="btn bg-blue-light text-white uppercase" href="/search/jobs">View all</a>
      </div>

      <div class="section-body">
        <div class="job-cards">
          <template v-for="(job, j) in results" :key="j">
            <block-job-card :index="j" :payload="job"></block-job-card>
          </template>
        </div>

        <aside class="section-sidebar">
          <div class="side-card">
            <h4 class="side-card-title">Did you know?</h4>
            <p v-html="computedPayload['side-text']"></p>
          </div>
        </aside>
      </div>

		</div>
	</section>
</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		name: 'HubJobs',

		props: {
			payload: {
				type: [Object,String]
			},
		},

		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'listings-test' : 'listings-live',
				searchObject: {
					hitsPerPage: 3,
					facets: ['slug'],
					facetFilters: [["published:true"]]
				},
				results: false
			}
		},

		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);

      console.log('HUBPAGE:JOBS:', this.computedPayload);
      // Set hitsPerPage to length of this.computedPayload.slugs array.
      // Loop through this.computedPayload.slugs and prefixing them with 'slugs:', then add them to facetFilters.
      this.searchObject.hitsPerPage = this.computedPayload.slugs.length;
      this.searchObject.facetFilters.push(this.computedPayload.slugs.map(el => `slug:${el}`));

			this.index
				.search('', this.searchObject)
				.then((results) => {
					console.log("Hub jobs search raw results:", results);
					if (results.nbHits > 0) {
						this.results = results.hits;
					} else {
						this.results = false;
					}
				});
		},

    computed: {
      computedPayload() {
        return typeof this.payload === 'string' ? JSON.parse(this.payload) : this.payload;
      },
    }
	}
</script>
